var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0V23H12.2489V14.1156H9.25461V10.4887H12.2489V7.44279C12.2489 5.22758 14.0447 3.43181 16.2599 3.43181H19.3902V6.69318H17.1503C16.4464 6.69318 15.8758 7.26383 15.8758 7.96771V10.4888H19.3339L18.856 14.1156H15.8758V23H23V0H0Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
